import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from '@/store.js';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/generic/:raceID/',
      name: 'generic',
      component: () => import('./views/Generica.vue')
    },
    {
      path: '/player/:vimeoURL/',
      name: 'player',
      component: () => import('./views/Player.vue')
    }
  ]
});



export default router;
